import { ColDef } from 'ag-grid-community';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { notNull } from '../../../utils';
import { TableColumnsResizedAction, TableSettingsColumn } from '../types';

export const useAgTableColumnResize = <T>(
    cols: ColDef<T>[],
    columnSettings: TableSettingsColumn[],
    columnsResized: TableColumnsResizedAction
) => {
    const dispatch = useDispatch();

    const resizableColumns = useMemo(
        () =>
            cols
                .map(column => {
                    const columnSetting = columnSettings.find(col => col.key === column.field);
                    if (columnSetting == null) {
                        return column;
                    }
                    return { ...column, width: columnSetting?.width ?? column.width };
                })
                .filter(notNull) as ColDef<T>[],
        [columnSettings, cols]
    );

    // Todo: Use rxjs, debounce and filter out nondistinct values
    const saveColumnWidth = useCallback(
        (idx: number, width: number) => {
            const columnKey = resizableColumns[idx].colId ?? resizableColumns[idx].field ?? '';
            dispatch(columnsResized({ columnKey, width: width }));
        },
        [dispatch, columnsResized, resizableColumns]
    );

    return { resizableColumns, saveColumnWidth };
};
